import React, { useState } from "react";
// import { Card, Spinner } from "react-bootstrap";
import defaultZone from "../../assets/img/icon/GPS/location.png";
import selectZone from "../../assets/img/icon/GPS/selectLocation.svg";
import greenZone from "../../assets/img/icon/GPS/location_green.svg";
// import FloorplanSelector from "./FloorplanSelector";
// import api from "../../api";
// import { globalConfig } from "../../config";
import ReaderSelector from "./ReaderSelector";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faHeartbeat } from "@fortawesome/free-solid-svg-icons";
// import moment from "moment-timezone";
// import { NavLink } from "react-router-dom";
// import {
//   getDistance,
//   middle,
//   radiusZoomLevel,
// } from "../../utils/staticMethods";
// import { Grid, Link } from "react-feather";
// import axios from "axios";
// import GoogleMapReact from "../../components/maps/GoogleMapReact";
import CommonMap from "../../components/maps/CommonMap";
// import { CommonMapProvider } from "../../contexts/CommonMapContext";
import { withCommonMapProvider } from "../../utils/withCommonMapProvider";
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
  ControlPosition,
  MapControl,
  useMap,
} from "@vis.gl/react-google-maps";
import useCommonMap from "../../hooks/useCommonMap";

// let overlay1 = null;
// let source1 = null;
const ReaderView = () => {
  // const [mapInstance, setInstance] = useState();
  // const [mapApi, setApi] = useState();
  // const [picture, setPicture] = useState(null);
  // const [showReader, setShowReader] = useState(false);
  // const [showSearch, setShowSearch] = useState(true);
  // const [curFloor, setCurFloor] = useState(null);
  // const [loadingPlan, setLoadingPlan] = useState(false);
  // const [reader, setReader] = useState(null);
  // const [readers, setReaders] = useState([]);
  // const [hideOtherFloors, setHideOtherFloors] = useState(false);

  const [showReader] = useState(false);
  // const [showSearch, setShowSearch] = useState(true);
  const [reader, setReader] = useState(null);
  const [readers, setReaders] = useState([]);

  const [hideOtherFloors, setHideOtherFloors] = useState(false);

  // const commonMapRef = React.useRef();
  const map = useMap();

  const onSelectReader = (data) => {
    setReader(data);
    // console.log("%s", JSON.stringify(data));
    map.setCenter({ lat: Number(data.latitude), lng: Number(data.longitude) });
    map.setZoom(20);
  };

  const getZoneIcon = (item) => {
    if (item.id === reader?.id) return selectZone;
    if (item.wirepas) return greenZone;
    return defaultZone;
  };

  // useEffect(() => {
  //   if (mapApi && mapInstance && curFloor) {
  //     getPci();
  //     setLoadingPlan(true);
  //   }
  // }, [mapApi, mapInstance, curFloor]);

  // useEffect(() => {
  //   if (mapInstance) {
  //     if (!reader.latitude || !reader.longitude) {
  //       mapInstance.setZoom(5);
  //     } else {
  //       mapInstance.setZoom(23);
  //     }
  //   }
  // }, [reader]);

  // const getPci = () => {
  //   if (source1) {
  //     source1.cancel("request canceled");
  //   }
  //   source1 = axios.CancelToken.source();
  //   api
  //     .get(`files/floorplans/${curFloor.id}`, {
  //       responseType: "arraybuffer",
  //       cancelToken: source1.token,
  //     })
  //     .then((res) => {
  //       let blob = new Blob([res.data], { type: "img/jpeg" });
  //       let url = (window.URL || window.webkitURL).createObjectURL(blob);
  //       setPicture(url);
  //     })
  //     .catch(() => setPicture(null));
  // };

  // useEffect(() => {
  //   if (picture) initFloorPlan();
  // }, [mapApi, mapInstance, picture]);

  // useEffect(() => {
  //   return () => {
  //     if (source1) {
  //       source1.cancel("request canceled");
  //     }
  //   };
  // }, []);

  // const initFloorPlan = () => {
  //   if (mapApi && mapInstance && picture) {
  //     mapInstance.setHeading(360 - curFloor?.rotation || 0);
  //     if (overlay1) {
  //       overlay1.setMap(null);
  //       overlay1 = null;
  //     }
  //     let northWest = new mapApi.LatLng(
  //       curFloor ? Number(curFloor.northWestLatitude || 51.5072) : 51.5072,
  //       curFloor ? Number(curFloor.northWestLongitude) || 0.1276 : 0.1276
  //     );
  //     let southEast = new mapApi.LatLng(
  //       curFloor ? Number(curFloor.southEastLatitude || 51.5072) : 51.5072,
  //       curFloor ? Number(curFloor.southEastLongitude) || 0.1276 : 0.1276
  //     );
  //     overlay1 = new mapApi.OverlayView();
  //     overlay1.div = null;
  //     window.overlay = overlay1;
  //     overlay1.image = picture;
  //     overlay1.draw = function () {
  //       const overlayProjection = this.getProjection();
  //       const se = overlayProjection.fromLatLngToDivPixel(southEast);
  //       const nw = overlayProjection.fromLatLngToDivPixel(northWest);
  //       if (this.div) {
  //         this.div.style.left = nw.x + "px";
  //         this.div.style.top = nw.y + "px";
  //         this.div.style.width = se.x - nw.x + "px";
  //         this.div.style.height = se.y - nw.y + "px";
  //       }
  //     };
  //     overlay1.onRemove = function () {
  //       if (this.div) {
  //         this.div.parentNode.removeChild(this.div);
  //       }
  //     };
  //     overlay1.onAdd = function () {
  //       this.div = document.createElement("div");
  //       this.div.id = "whole-container";
  //       this.div.style.borderStyle = "none";
  //       this.div.style.borderWidth = "0px";
  //       this.div.style.position = "absolute";
  //       this.div.style.visibility = "visible";

  //       const img = document.createElement("img");

  //       img.src = this.image;
  //       img.style.width = "100%";
  //       img.style.height = "100%";
  //       img.style.position = "absolute";
  //       this.div.appendChild(img);
  //       const panes = this.getPanes();
  //       panes.overlayLayer.appendChild(this.div);
  //     };
  //     overlay1.setMap(mapInstance);
  //     let d = getDistance(northWest, southEast);
  //     let keys = Object.keys(radiusZoomLevel).reverse();
  //     let value = 1000000;
  //     let index = 0;
  //     for (let i = 0; i < keys.length; i++) {
  //       let v = Math.abs(radiusZoomLevel[keys[i]] - d);
  //       if (v < value) {
  //         value = v;
  //         index = keys[i];
  //       }
  //     }
  //     mapInstance.setCenter(middle(northWest, southEast));
  //     mapInstance.setZoom(Number(index) - 1);
  //     setTimeout(() => setLoadingPlan(false), 500);
  //   }
  // };

  // const apiHasLoaded = (map, maps) => {
  //   if (!map || !maps) return;
  //   setInstance(map);
  //   setApi(maps);
  //   let thePanorama = map.getStreetView();
  //   maps.event.addListener(thePanorama, "visible_changed", function () {
  //     if (thePanorama.getVisible()) {
  //       setShowSearch(false);
  //     } else {
  //       setShowSearch(true);
  //     }
  //   });
  // };

  // const onSelect = (data) => {
  //   setCurFloor(data);
  // };

  // const onSelectReader = (data) => {
  //   setReader(data);
  // };

  // const cancelOption = () => {
  //   setShowReader((prevState) => {
  //     return !prevState;
  //   });
  // };

  // const getZoneIcon = (item) => {
  //   if (item.id === reader?.id) return selectZone;
  //   if (item.wirepas) return greenZone;
  //   return defaultZone;
  // };

  return (
    <CommonMap
      height="calc(100vh - 280px)"
      type={"editReaders"}
      showMapDetail={false}
      showNearByAssets={false}
      showNearByZones={true}
      showAllLabels={false}
      showHashTagFilter={false}
      showCategoryFilter={false}
      // ref={commonMapRef}
      // showReaders={true}
      // onSelectedReaderChanged={onSelectReader}
      floorplanMode={"view"}
    >
      <ReaderSelector
        reader={reader}
        getAllReaders={(e) => setReaders(e)}
        onSelect={onSelectReader}
        showDefault
        showReader={showReader}
      />
      <MapControl position={ControlPosition.TOP_LEFT}>
        <div
          // className="d-flex justify-content-between align-items-center px-0"
          className="d-flex flex-row justify-content-start align-items-center px-2 bg-light text-dark"
          style={{
            margin: "10px",
            width: "150px",
            maxHeight: "32px",
            borderRadius: "3px",
          }}
        >
          <input
            type="checkbox"
            id="hide-01"
            checked={hideOtherFloors}
            className="mx-0 px-1 text-dark"
            style={{
              border: "1px solid #7f838e",
              borderRadius: "3px",
              fontSize: "12px",
              maxHeight: "32px",
              minHeight: "32px",
            }}
            onChange={(e) => {
              setHideOtherFloors(e.target.checked);
            }}
          />
          <label
            className="px-1 m-0 align-top text-dark"
            aria-details="kdkd"
            htmlFor="hide-01"
          >
            Hide Other Floors
          </label>
        </div>
      </MapControl>

      {map &&
        readers.map((item) => {
          return (
            <GeoMarker
              key={item.id}
              onSelect={() => {
                onSelectReader(item);
              }}
              item={item}
              lat={item.latitude}
              lng={item.longitude}
              selected={item.id === reader?.id}
              defaultZone={getZoneIcon(item)}
              hideOtherFloors={hideOtherFloors}
            />
          );
        })}
    </CommonMap>
  );
};

// const getBackground = (item, defaultZone) => {
//   if (defaultZone) return "bg-primary";
//   if (item.wirepas) return "bg-success";
//   return "bg-danger";
// };

const GeoMarker = ({
  lat,
  lng,
  defaultZone,
  onSelect,
  item,
  selected,
  hideOtherFloors,
}) => {
  const commonMap = useCommonMap();
  const { selectedFloorplan: curFloor } = { commonMap };
  const sameAltitude =
    (curFloor?.altitude ?? 0) === (item.altitude ?? 0) ||
    (curFloor?.altitude ?? 0) === -1;

  if (!sameAltitude && hideOtherFloors) return null;

  return (
    // <AdvancedMarker
    //   position={{ lat: Number(lat), lng: Number(lng) }}
    //   anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
    // >
    //   <div
    //     style={{
    //       marginLeft: "-15px",
    //       marginTop: "-15px",
    //       opacity: sameAltitude ? "100%" : "33%",
    //     }}
    //   >
    //     <img
    //       alt="marker"
    //       onClick={() => onSelect()}
    //       style={{ height: "30px", width: "30px", cursor: "pointer" }}
    //       src={defaultZone}
    //     />
    //     <div
    //       className={`text-black position-absolute marker-position-bottom ps-1 pe-1 radius-3 text-nowrap font-weight-bold ${getBackground(
    //         item,
    //         selected
    //       )}`}
    //       style={{ fontSize: "14px", transform: "translate(-50%, 50%)" }}
    //     >
    //       {item?.serial}
    //     </div>
    //   </div>
    // </AdvancedMarker>
    <AdvancedMarker
      position={{
        lat: Number(lat),
        lng: Number(lng),
      }}
      anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
      clickable={true}
      onClick={() => onSelect()}
    >
      <img
        src={defaultZone}
        width={"30px"}
        alt="Marker"
        onClick={() => onSelect()}
      />
      <div
        className="px-1 text-nowrap text-black bg-primary bg-opacity-75 rounded"
        style={{
          position: "absolute",
          top: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          marginTop: 4,
          pointerEvents: "none",
        }}
      >
        {item?.serial}
      </div>
    </AdvancedMarker>
  );
};

// const getBackground = (item, defaultZone) => {
//   if (defaultZone) return "bg-primary";
//   if (item.wirepas) return "bg-success";
//   return "bg-danger";
// };

// const GeoMarker = ({
//   defaultZone,
//   onSelect,
//   item,
//   selected,
//   curFloor,
//   hideOtherFloors,
// }) => {
//   const sameAltitude =
//     (curFloor?.altitude ?? 0) === (item.altitude ?? 0) ||
//     (curFloor?.altitude ?? 0) === -1;

//   if (!sameAltitude && hideOtherFloors) return null;

//   return (
//     <div
//       style={{
//         marginLeft: "-15px",
//         marginTop: "-15px",
//         opacity: sameAltitude ? "100%" : "33%",
//       }}
//     >
//       <img
//         alt="marker"
//         onClick={() => onSelect()}
//         style={{ height: "30px", width: "30px", cursor: "pointer" }}
//         src={defaultZone}
//       />
//       <div
//         className={`text-black position-absolute marker-position-bottom ps-1 pe-1 radius-3 text-nowrap font-weight-bold ${getBackground(
//           item,
//           selected
//         )}`}
//         style={{ fontSize: "14px", transform: "translate(-50%, 50%)" }}
//       >
//         {item?.serial}
//       </div>
//     </div>
//   );
// };

export default withCommonMapProvider(ReaderView);
